import { render, staticRenderFns } from "./OnboardingCity.vue?vue&type=template&id=5e18155d&"
import script from "./OnboardingCity.vue?vue&type=script&lang=js&"
export * from "./OnboardingCity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports